// pages/components/ProtectedRoutes.jsx
import React from 'react';
import { useAuth } from '../../_auth/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, isAuthenticated, userInDatabase, login, logout } = useAuth(); // ✅ Agregar login y logout aquí

  // Estado 1: Cargando
  if (loading) {
    return (
      <div className="login-container" style={{
        minHeight: '100vh',
        background: '#f6f6f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Segoe UI, system-ui, sans-serif'
      }}>
        <div className="login-content" style={{
          background: 'white',
          padding: '3rem 2.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          textAlign: 'center',
          border: '1px solid #e1e5e9',
          minWidth: '380px'
        }}>
          <div style={{ marginBottom: '2rem' }}>
            <div style={{
              width: '60px',
              height: '60px',
              background: 'linear-gradient(135deg, #0078d4 0%, #005a9e 100%)',
              borderRadius: '50%',
              margin: '0 auto 1.5rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '24px',
              color: 'white',
              fontWeight: 'bold'
            }}>
              ⏳
            </div>
            <h2 style={{ color: '#323130', margin: '0 0 0.5rem 0' }}>
              Verificando acceso
            </h2>
            <p style={{ color: '#605e5c', margin: 0 }}>
              Validando credenciales...
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Estado 2: No autenticado con Microsoft
  if (!isAuthenticated || !user) {
    return (
      <div className="login-container" style={{
        minHeight: '100vh',
        background: '#f6f6f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Segoe UI, system-ui, sans-serif'
      }}>
        <div className="login-content" style={{
          background: 'white',
          padding: '3rem 2.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          textAlign: 'center',
          border: '1px solid #e1e5e9',
          minWidth: '380px'
        }}>
          <div style={{ marginBottom: '2rem' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '2rem',
              gap: '12px'
            }}>
              <div style={{
                width: '32px',
                height: '32px',
                background: '#0078d4',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold'
              }}>
                VSC
              </div>
              <span style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#323130'
              }}>Qualtia - Portal Venta sin cargo</span>
            </div>

            <h1 style={{
              color: '#323130',
              margin: '0 0 1rem 0',
              fontSize: '24px',
              fontWeight: '300',
              letterSpacing: '-0.5px'
            }}>
              Iniciar sesión
            </h1>
            
            <p style={{
              color: '#605e5c',
              margin: '0 0 2rem 0',
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              Use su cuenta Microsoft corporativa
            </p>
            <br/>            
            <button 
              onClick={login} // ✅ Ahora login está definido
              disabled={loading}
              style={{
                padding: '12px 24px',
                backgroundColor: '#ffffff',
                color: '#5e5e5e',
                border: '2px solid #8a8886',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '15px',
                fontWeight: '600',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                transition: 'all 0.2s ease'
              }}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M7.5 7.5H0V0H7.5V7.5Z" fill="#F1511B"/>
                <path d="M16 7.5H8.5V0H16V7.5Z" fill="#80CC28"/>
                <path d="M7.5 16H0V8.5H7.5V16Z" fill="#00ADEF"/>
                <path d="M16 16H8.5V8.5H16V16Z" fill="#FBBC09"/>
              </svg>
              Continuar con Microsoft
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Estado 3: Autenticado con Microsoft pero NO en BD
  if (userInDatabase === false) {
    return (
      <div className="login-container" style={{
        minHeight: '100vh',
        background: '#f6f6f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Segoe UI, system-ui, sans-serif'
      }}>
        <div className="login-content" style={{
          background: 'white',
          padding: '3rem 2.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          textAlign: 'center',
          border: '1px solid #e1e5e9',
          minWidth: '400px'
        }}>
          <div style={{ marginBottom: '2rem' }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: '#ff4444',
              borderRadius: '50%',
              margin: '0 auto 1.5rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '32px',
              color: 'white'
            }}>
              ⚠️
            </div>
            <h1 style={{
              color: '#d13438',
              margin: '0 0 1rem 0',
              fontSize: '24px',
              fontWeight: '600'
            }}>
              Acceso no autorizado
            </h1>
            
            <p style={{
              color: '#605e5c',
              margin: '0 0 0.5rem 0',
              fontSize: '16px',
              lineHeight: '1.5'
            }}>
              <strong>Usuario: {user.username}</strong>
            </p>            
            <p style={{
              color: '#605e5c',
              margin: '0 0 2rem 0',
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              No cuenta con permisos para acceder al portal o esta fuera de la red corporativa. 
              Contacte al administrador del sistema.
            </p>
          </div>          
          <div style={{
            marginTop: '2rem',
            padding: '1rem',
            background: '#fff4ce',
            borderRadius: '4px',
            border: '1px solid #ffaa44',
            fontSize: '12px',
            color: '#8a6500'
          }}>
            <strong>Información:</strong> Su cuenta Microsoft es válida pero no está registrada en el sistema.
          </div>
        </div>
      </div>
    );
  }
  // Estado 4: Todo correcto - mostrar la aplicación
  return children;
};

export default ProtectedRoute;